import { DELETE } from "../../APiHelper/API";

export const deletePlayer = (player_id, onSuccess, onError) => {

    DELETE(`/api/v1/leagues/teams/players/${player_id}`, onSuccess, onError)
}